import { render, staticRenderFns } from "./widget_your_photo.vue?vue&type=template&id=724f0c2a&scoped=true&"
import script from "./widget_your_photo.vue?vue&type=script&lang=js&"
export * from "./widget_your_photo.vue?vue&type=script&lang=js&"
import style0 from "./widget_your_photo.vue?vue&type=style&index=0&id=724f0c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f0c2a",
  null
  
)

export default component.exports